import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';
import { getPlanningsBreakdown } from '@/utils/vhub-utils';


/**
 * Score according to whether all planned meetings are effectively done or not
 */
export default new VitalityCriterion({
  titleTr: 'VH_M_ON_SCHEDULE',
  key: 'meetingSchedule',
  weight: 2,

  score: ({ meetings, plannings }, range) => {
    const {
      nTotalExpected,
      nTotalExpectedDone,
      nTotalExpectedNotDone,
    } = getPlanningsBreakdown(plannings, meetings, range, 'id', 'planningId');

    const noPlannings = nTotalExpected === 0;
    const score = noPlannings
      ? 0
      : 100 - (nTotalExpectedNotDone * 100 / nTotalExpected);

    return {
      score,
      data: {
        value: nTotalExpectedNotDone,
        noTopsFlops: noPlannings,
        noCategoryHint: noPlannings,
        nTotalExpected,
        nTotalExpectedDone,
      },
    };
  },

  text: ({ value, nTotalExpected, nTotalExpectedDone }) => {
    if (nTotalExpected === 0) {
      return i18n.t('message.VH_M_ON_SCHEDULE_NONE_PLANNED');
    }
    return i18n.t('message.VH_M_ON_SCHEDULE_TEXT', {
      nPlanned: nTotalExpected,
      nCompleted: nTotalExpectedDone,
    });
  },

});
